import { ApolloClient, from, InMemoryCache } from '@apollo/client';

import { errorLink } from '../links/errorLink';
import { headersLink } from '../links/headersLink';
import { httpLink } from '../links/httpLink';
import { redirectOnPage403Link } from '../links/redirectOnPage403Link';
import { redirectOnPage404Link } from '../links/redirectOnPage404Link';
import { typePolicies } from '../typePolicies';
import { EnvUtils } from '@/utils/env.utils';
import { customErrorMessageLink } from '../links/customErrorMessageLink';
import { loadingAnimationLink } from '../links/loadingAnimationLink';

export const apolloClientContracts = new ApolloClient({
  link: from([
    loadingAnimationLink,
    errorLink,
    customErrorMessageLink,
    redirectOnPage403Link,
    redirectOnPage404Link,
    headersLink.concat(httpLink(process.env.GRAPHQL_SERVER_ENDPOINT_CONTRACTS)),
  ]),
  cache: new InMemoryCache({
    typePolicies,
  }),
  connectToDevTools: EnvUtils.isDevelopment(),
});
